/**
 * ForecastIcon — Mi6 custom glyph: target with crosshair + trending arrow
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function ForecastIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Outer circle */}
      <circle cx="38" cy="40" r="22" stroke="currentColor" strokeWidth="1.5" />
      {/* Mid circle */}
      <circle cx="38" cy="40" r="13" stroke="currentColor" strokeWidth="1.5" />
      {/* Bull's-eye */}
      <circle cx="38" cy="40" r="4.5" stroke="currentColor" strokeWidth="1.5" />
      {/* Crosshair lines */}
      <line x1="38" y1="14" x2="38" y2="24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="38" y1="56" x2="38" y2="66" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="12" y1="40" x2="22" y2="40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Right crosshair broken by trending arrow */}
      <line x1="54" y1="40" x2="64" y2="40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Trending-up arrow in upper-right */}
      <polyline points="56,26 63,19 70,19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <line x1="63" y1="19" x2="63" y2="25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
